import API_BASE_URL from "../RestAPI";

const BASE = `${API_BASE_URL.replace(/\/$/, "")}/task-assignments`;
const CORE = `${API_BASE_URL.replace(/\/$/, "")}/core`;

const getAuthHeaders = () => {
    const token = localStorage.getItem("authToken");
    const headers = { "Content-Type": "application/json" };
    if (token) headers.Authorization = `Bearer ${token}`;
    return headers;
};

const handle = async (res, fallbackMsg) => {
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status === "fail") {
        throw new Error(data.message || fallbackMsg);
    }
    return data;
};

export const taskAssignmentsApi = {
    // ── Admin management (requires 'Task Assignment' permission) ──
    getAssignments: async (params = {}) => {
        const query = new URLSearchParams(params).toString();
        const url = query ? `${BASE}/assignment/?${query}` : `${BASE}/assignment/`;
        const res = await fetch(url, { method: "GET", headers: getAuthHeaders() });
        return handle(res, "Failed to fetch tasks");
    },

    createAssignment: async (payload) => {
        const res = await fetch(`${BASE}/assignment/`, {
            method: "POST", headers: getAuthHeaders(), body: JSON.stringify(payload),
        });
        return handle(res, "Failed to create task");
    },

    updateAssignment: async (payload) => {
        const res = await fetch(`${BASE}/assignment/`, {
            method: "PUT", headers: getAuthHeaders(), body: JSON.stringify(payload),
        });
        return handle(res, "Failed to update task");
    },

    deleteAssignment: async (id) => {
        const res = await fetch(`${BASE}/assignment/?id=${id}`, { method: "DELETE", headers: getAuthHeaders() });
        return handle(res, "Failed to delete task");
    },

    // ── Assignee view (any authenticated user) ──
    getMyTasks: async (params = {}) => {
        const query = new URLSearchParams(params).toString();
        const url = query ? `${BASE}/my-tasks/?${query}` : `${BASE}/my-tasks/`;
        const res = await fetch(url, { method: "GET", headers: getAuthHeaders() });
        return handle(res, "Failed to fetch my tasks");
    },

    // ── Progress updates (admin or the task's assignee) ──
    getProgress: async (taskId) => {
        const res = await fetch(`${BASE}/progress/?task_id=${taskId}`, { method: "GET", headers: getAuthHeaders() });
        return handle(res, "Failed to fetch progress");
    },

    addProgress: async (payload) => {
        const res = await fetch(`${BASE}/progress/`, {
            method: "POST", headers: getAuthHeaders(), body: JSON.stringify(payload),
        });
        return handle(res, "Failed to update progress");
    },

    // ── Employees for the assignee dropdown ──
    getEmployees: async () => {
        const res = await fetch(`${CORE}/employee/`, { method: "GET", headers: getAuthHeaders() });
        return handle(res, "Failed to fetch employees");
    },
};

export const TASK_STATUSES = [
    { value: "TODO", label: "Todo" },
    { value: "IN_PROGRESS", label: "In Progress" },
    { value: "HOLD", label: "Hold" },
    { value: "DONE", label: "Done" },
    { value: "CANCELLED", label: "Cancelled" },
];

export const TASK_PRIORITIES = [
    { value: "LOW", label: "Low" },
    { value: "MEDIUM", label: "Medium" },
    { value: "HIGH", label: "High" },
];

export const statusLabel = (value) =>
    (TASK_STATUSES.find((s) => s.value === value) || {}).label || value || "-";
